import moment from 'moment';
import { SecurityModel } from 'api';
import { getBooleanValue, getNumberValue, getStringValue } from 'utilities';
import dividendsPerShareAtDate from 'utilities/dividendsPerShareAtDate';
import { ReverseParsedDividendRateLedgerItem } from '../components/dividend-rate-ledger/config/types';

const calculateDividendsForMultipleDivRates = (
  dividendRateLedgerItems: ReverseParsedDividendRateLedgerItem[],
  baseSecurity: SecurityModel,
  measurementDate: string
) => {
  const items = dividendRateLedgerItems;
  const valuesByTimeWindow = new Array(items.length)
    .fill(null)
    .map(() => ({ end_share_value: 0, accrued_dividends: 0 }));

  const securityIssuePrice = getNumberValue(baseSecurity.issue_price);
  const securityShares = getNumberValue(baseSecurity.shares_outstanding);

  items.forEach((item, currentIdx) => {
    const { effective_date, dividend_rate, has_compounding, compounding_periods } = item;
    const effectiveDate = currentIdx === 0 ? getStringValue(baseSecurity.investment_date) : item.effective_date;
    const endDate = items[currentIdx + 1]?.effective_date ?? measurementDate;
    const dividendRate = Number(dividend_rate);
    const windowIssuePrice =
      currentIdx === 0 || !has_compounding ? securityIssuePrice : valuesByTimeWindow[currentIdx - 1].end_share_value;

    if (moment(effective_date).isAfter(measurementDate)) {
      return;
    }
    const accrualPeriodEndDate = moment(endDate).isAfter(measurementDate) ? measurementDate : endDate;

    const dividendsPerShare = dividendsPerShareAtDate({
      hasCumulativeDividends: true,
      periodStartDate: effectiveDate,
      hasCompounding: getBooleanValue(has_compounding),
      periodEndDate: accrualPeriodEndDate,
      periodIssuePrice: windowIssuePrice,
      compoundingPeriods: compounding_periods,
      dividendRate,
    });
    valuesByTimeWindow[currentIdx].end_share_value = windowIssuePrice + dividendsPerShare;
    valuesByTimeWindow[currentIdx].accrued_dividends = dividendsPerShare * securityShares;
  });
  return valuesByTimeWindow.reduce((acc, item) => acc + item.accrued_dividends, 0);
};
export default calculateDividendsForMultipleDivRates;
